import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getConstructiveAvailableColumns } from './api';

export const path = '/constructive/list';

const PageConstructiveList: React.FC = (props) => {
  const ConstructiveList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getConstructiveAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ConstructiveList {...props} />;
};

export default PageConstructiveList;
